export default {
  name: 'wisk-sort',
  width: 35,
  height: 35,
  paths: [
    { d: 'M18.7,0.4L29,11c0.4,0.5,0.4,1.2,0,1.6c-0.2,0.2-0.5,0.3-0.8,0.3H6.9c-0.6,0-1.2-0.5-1.2-1.2c0-0.3,0.1-0.6,0.4-0.8L17,0.3 C17.5-0.1,18.2-0.1,18.7,0.4C18.7,0.4,18.7,0.4,18.7,0.4z' },
    { d: 'M18.7,34.6L29,24c0.4-0.5,0.4-1.2,0-1.6c-0.2-0.2-0.5-0.3-0.8-0.3H6.9c-0.6,0-1.2,0.5-1.2,1.2c0,0.3,0.1,0.6,0.4,0.8 L17,34.7C17.5,35.1,18.2,35.1,18.7,34.6C18.7,34.6,18.7,34.6,18.7,34.6z' }
  ]
}
